export const ALIGN_TO_FIELD_TYPES = ['Rectangle', 'Product Image', 'Background Theme Image'];
